export default __webpack_public_path__ + "static/media/overview-icon.31a7d535.svg";